import { modalsSelectors } from '@sv-support-sdk/store';

import { CONTACT_US_MODAL } from '../../constants/modals';
import { RootState } from '..';

export const { selectOpenedModals } = modalsSelectors;

export const selectContactUsModal = (state: RootState) =>
  state.modals.openedModals.find((modal) => modal.name === CONTACT_US_MODAL);
